import { NavLink } from 'react-router-dom';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from './Sidebar.module.css';
import dashboardIcon from '../../../assets/images/dashboard.png';
// import reportsIcon from '../../../assets/images/reports.png';
// import moneyTransfersIcon from '../../../assets/images/moneyTransfers.png';
// import settingsIcon from '../../../assets/images/settings.png';
// import roleSelectionIcon from '../../../assets/images/roleSelection.png';
import UserContext from '../../../context/user-context';

function Sidebar() {
  const { t } = useTranslation();
  const userCtx = useContext(UserContext);

  return (
    <aside className={styles.container}>
      <div className={styles.navigation}>
        {userCtx.isLoggedIn && (
          <>
            <NavLink to='/' className={({ isActive }) => isActive
              ? classNames(styles.navLink, styles.activeLink)
              : styles.navLink}
            >
              <div className={styles.circle}>
                <img className={styles.icon} src={dashboardIcon} alt='' />
              </div>
              <span className={styles.text}>{t('pages.dashboard')}</span>
            </NavLink>
            {/* <NavLink to='/reports' className={({ isActive }) => isActive */}
            {/*   ? classNames(styles.navLink, styles.activeLink) */}
            {/*   : styles.navLink} */}
            {/* > */}
            {/*   <div className={styles.circle}> */}
            {/*     <img className={styles.icon} src={reportsIcon} alt='' /> */}
            {/*   </div> */}
            {/*   <span className={styles.text}>{t('pages.reports')}</span> */}
            {/* </NavLink> */}
            {/* <NavLink to='/money-transfer' className={({ isActive }) => isActive */}
            {/*   ? classNames(styles.navLink, styles.activeLink) */}
            {/*   : styles.navLink} */}
            {/* > */}
            {/*   <div className={styles.circle}> */}
            {/*     <img className={styles.icon} src={moneyTransfersIcon} alt='' /> */}
            {/*   </div> */}
            {/*   <span className={styles.text}>{t('pages.moneyTransfers')}</span> */}
            {/* </NavLink> */}
            {/* <NavLink to='/role-selection' className={({ isActive }) => isActive */}
            {/*   ? classNames(styles.navLink, styles.activeLink) */}
            {/*   : styles.navLink} */}
            {/* > */}
            {/*   <div className={styles.circle}> */}
            {/*     <img className={styles.icon} src={roleSelectionIcon} alt='' /> */}
            {/*   </div> */}
            {/*   <span className={styles.text}>{t('pages.roleSelection')}</span> */}
            {/* </NavLink> */}
            {/* <NavLink to='/settings' className={({ isActive }) => isActive */}
            {/*   ? classNames(styles.navLink, styles.activeLink) */}
            {/*   : styles.navLink} */}
            {/* > */}
            {/*   <div className={styles.circle}> */}
            {/*     <img className={styles.icon} src={settingsIcon} alt='' /> */}
            {/*   </div> */}
            {/*   <span className={styles.text}>{t('pages.settings')}</span> */}
            {/* </NavLink> */}
          </>
        )}
      </div>
    </aside>
  );
}

export default Sidebar;
